import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import AISuggestionCommand from './aisuggestioncommand';

export default class AISuggestionEditing extends Plugin {

  static get pluginName() {
    return 'AISuggestionEditing';
  }

  init() {
    console.log('AISuggestionEditing was initialized', this.editor);
    this._defineConverters();
    this.editor.commands.add('getAISuggestions', new AISuggestionCommand(this.editor, 'getAISuggestions'));
    this.editor.commands.add('removeSuggestionMarkers', new AISuggestionCommand(this.editor, 'removeSuggestionMarkers'));
  }

  _defineConverters() {
    const editor = this.editor;
    editor.conversion.for('editingDowncast').markerToHighlight({
      model: 'grammar',
      view: (data, conversionApi) => {
        // Assuming that the marker name is in a form of comment:commentType:commentId.
        const [, , suggestionId] = data.markerName.split(':');

        return {
          classes: 'grammar', //['comment', 'comment-' + commentType],
          attributes: {
            'id': "marker",
            'data-marker': suggestionId
          }
        };
      }
      // view: () => ({
      //   classes: 'grammar',
      //   attributes: {
      //     'id': "marker",
      //     'data-marker': uuid()
      //   }
      // })
    });

    editor.conversion.for('editingDowncast').markerToHighlight({
      model: 'passive',
      view: (data, conversionApi) => {
        // Assuming that the marker name is in a form of comment:commentType:commentId.
        const [, , suggestionId] = data.markerName.split(':');

        return {
          classes: 'passive', //['comment', 'comment-' + commentType],
          attributes: {
            'id': "marker",
            'data-marker': suggestionId
          }
        };
      }
      // view: () => ({
      //   classes: 'grammar',
      //   attributes: {
      //     'id': "marker",
      //     'data-marker': uuid()
      //   }
      // })
    });

    editor.conversion.for('editingDowncast').markerToHighlight({
      model: 'preadability',
      view: (data, conversionApi) => {
        // Assuming that the marker name is in a form of comment:commentType:commentId.
        const [, , suggestionId] = data.markerName.split(':');

        return {
          classes: 'preadability', //['comment', 'comment-' + commentType],
          attributes: {
            'id': "marker",
            'data-marker': suggestionId
          }
        };
      }
      // view: () => ({
      //   classes: 'preadability'
      // })
    });

    editor.conversion.for('editingDowncast').markerToHighlight({
      model: 'sentiment',
      view: (data, conversionApi) => {
        // Assuming that the marker name is in a form of comment:commentType:commentId.
        const [, , suggestionId] = data.markerName.split(':');

        return {
          classes: 'sentiment', //['comment', 'comment-' + commentType],
          attributes: {
            'id': "marker",
            'data-marker': suggestionId
          }
        };
      }
      // view: () => ({
      //   classes: 'preadability'
      // })
    });

    editor.conversion.for('editingDowncast').markerToHighlight({
      model: 'emotion',
      view: (data, conversionApi) => {
        // Assuming that the marker name is in a form of comment:commentType:commentId.
        const [, , suggestionId] = data.markerName.split(':');

        return {
          classes: 'emotion', //['comment', 'comment-' + commentType],
          attributes: {
            'id': "marker",
            'data-marker': suggestionId
          }
        };
      }
      // view: () => ({
      //   classes: 'preadability'
      // })
    });
  }

}